import type { NotificationGroupOverviewTranslations } from './notificationTranslations';

/**
 * Only the backoffice shows the primary contact or links to a member page, and the
 * backoffice apps are English-only, so this copy stays out of the translations contract.
 */
export const PRIMARY_CONTACT_LABEL = 'Primary contact';
export const PRIMARY_CONTACT_COLUMN_DESCRIPTION =
  'The person we contact on behalf of the organization when we need to reach the group.';
export const PRIMARY_CONTACT_TOGGLE_DESCRIPTION =
  'We contact this person on behalf of the organization. Only one member at a time.';
export const MEMBER_DETAILS_LABEL = 'Member details';
/** The backend keeps exactly one, so the role moves by naming a successor, never by unsetting. */
export const PRIMARY_CONTACT_LOCKED_HINT = 'To move this, make another member the primary contact.';

type RestrictionArgs = {
  /** Already resolved by the sheet, which also shows it above a 403 on the account half. */
  accountReason: string | undefined;
  canEditNotifications: boolean;
  canManageAdmin: boolean;
  canAssignDrivers: boolean;
  translations: NotificationGroupOverviewTranslations;
};

/**
 * What this viewer may not change, as one paragraph for the top of the sheet — a
 * reason under every locked section would repeat the same sentence three times.
 */
export const buildRestrictionReasons = ({
  accountReason,
  canEditNotifications,
  canManageAdmin,
  canAssignDrivers,
  translations: t
}: RestrictionArgs): string[] =>
  [
    accountReason,
    !canEditNotifications
      ? t.adminEditsRest
      : !canManageAdmin || !canAssignDrivers
        ? t.roleAndDriversAdminOnly
        : undefined
  ].filter((reason): reason is string => !!reason);
